// analytics.ts
export const logEvent = (action: string, params?: Record<string, any>) => {
  if (typeof window.gtag !== "function") {
    console.warn("gtag is not defined");
    return;
  }
  window.gtag("event", action, params);
};

export const logPageView = (params?: Record<string, any>) => {
  logEvent('page_view', { params });
}
